import { FormGroup, FormGroupProps, FormItem, FormItemType, TextInput, isMobileView, useForm } from "@sis/react-library"
import { PersonDto } from "./FormSamplesFormGroupsPage"
import { Box, Stack } from "@mui/material"
import { FormSamplesFormGroupsFGCarLeases } from "./FormSamplesFormGroupsFGCarLeases";

////////////////////////////////////////////////////////////////////////////////////////////////////////
// This is an example of how to use the FormGroup component.
// This component is an input component passed from the form.
// It also has FormItem components under it. The result will return an object for the persson
// to the parent component where Form is declared.
// ie. { personId:2, firstName:'Test', lastName:'Test' }
////////////////////////////////////////////////////////////////////////////////////////////////////////
// allow no members for shorter name to be more readable below
// eslint-disable-next-line
interface T extends PersonDto { }

interface FormSamplesFormGroupsFGPersonProps {
    heading: string;
}

export const FormSamplesFormGroupsFGPerson = ({
    heading,
    ...formGroupProps  // The entire formGroupProps needs to be passed to the FormGroup component below
}: FormSamplesFormGroupsFGPersonProps & FormGroupProps<T>) => {

    const isMobile = isMobileView();

    const { id } = formGroupProps;
    // When using useForm - use the id (and not the Formname) to get this instance of the form group.
    const { getItem } = useForm<T>(id!);

    const handleFirstNameChange = (value: FormItemType) => {
        const lastNameField = getItem('lastName');
        console.log(`First name is now '${value as string}', last name is currently '${lastNameField.value as string}'`);
    }

    return (
        <FormGroup<T>
            {...formGroupProps} // We need to pass all FormGroupProps passsed into this component
            additionalItems={[{ name: "personId" }]}
        >
            <Box sx={{ border: '1px solid lightgrey', borderRadius: '4px', padding: '10px', marginTop: 2 }}>
                <Box sx={{ fontWeight: 'bold' }}>{heading}</Box>
                <Stack direction={isMobile ? 'column' : 'row'} spacing={isMobile ? 0 : 2}>
                    <FormItem<T>
                        formField="firstName"
                        label="First Name"
                        rules={[{ type: "required", message: "Please enter a first name!" }]}
                        onItemChange={handleFirstNameChange}
                        element={<TextInput maxLength={20} />}
                    />
                    <FormItem<T>
                        formField="lastName"
                        label="Last Name"
                        rules={[{ type: "required", message: "Please enter a last name!" }]}
                        element={<TextInput maxLength={20} />}
                    />
                    <FormItem<T>
                        formField="email"
                        label="Email"
                        rules={[{ type: "email", message: "Please enter a valid email!" }]}
                        element={<TextInput maxLength={50} />}
                    />
                </Stack>                
                <FormItem<T>
                    formField="carLeases"
                    label="Car Leases"
                    element={<FormSamplesFormGroupsFGCarLeases />}
                />
            </Box>
        </FormGroup>
    )
}
